import { Notification } from '@features/enterpriseNotifications/types';
import { notificationType } from '@features/notifications/NotificationsEnum';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import PaymentIcon from '@mui/icons-material/Payment';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import VideocamIcon from '@mui/icons-material/Videocam';
import { useTheme } from '@mui/material';
import { hireflixCta } from '@styles/colors';
import { FC } from 'react';

type NotificationIconProps = {
  notification: Notification;
};
const NotificationIcon: FC<NotificationIconProps> = ({ notification }) => {
  const theme = useTheme();
  switch (notification.notification_type) {
    case notificationType.APPLICANT_COMPLETED_ONBOARDING:
    case notificationType.ONBOARDING_DOCUMENT_EXPIRED:
    case notificationType.ONBOARDING_DOCS_WAITING:
    case notificationType.ONBOARDING_DOCS_RESEND:
    case notificationType.POST_HIRING_DOCS:
      return <ArticleOutlinedIcon sx={{ color: theme.palette.purple.main }} />;
    case notificationType.PENDING_JOB_OFFER:
    case notificationType.PENDING_INTERVIEW_INVITE:
    case notificationType.NO_CALENDAR_BLOCK:
      return (
        <CalendarMonthOutlinedIcon sx={{ color: theme.palette.success.main }} />
      );
    case notificationType.NEW_MESSAGE:
      return <MessageOutlinedIcon sx={{ color: theme.palette.primary.main }} />;
    case notificationType.AUTO_ACTION_PERFORMED:
      return <AutoModeIcon sx={{ color: theme.palette.primary.main }} />;
    case notificationType.COMPANY_MOVED_TO_SELF_BILLING:
      return <PaymentIcon sx={{ color: theme.palette.success.main }} />;
    case notificationType.HIREFLIX_INTERVIEW_COMPLETED:
      return <VideocamIcon sx={{ color: hireflixCta }} />;
    default:
      return <SettingsOutlinedIcon sx={{ color: theme.palette.yellow.main }} />;
  }
};

export default NotificationIcon;
